import React, { useState } from "react";
import Fade from "react-reveal/Fade";
import { FormattedMessage } from "react-intl";
import Dropdown from "@components/Dropdown/dropdown";
import locales from "@translations/locales";
import { changeLanguage } from "@translations/i18n";
import styles from "../header.module.scss";
import Cross from "@assets/images/svgs/cross.svg";
import HamburgerMenu from "@assets/images/svgs/hamburger-menu.svg";
import UniplacesLogo from "@assets/images/svgs/uniplaces-logo.svg";

const HOW_IT_WORKS_KEY = 'how_it_works';
const localesValues = Object.values(locales);

const HeaderMobile = ({ headerItems, locale }) => {
  const [show, setShow] = useState(false);
  const icon = show ?
    <Cross className={styles.header__crossIcon} /> :
    <HamburgerMenu className={styles.header__hamburgerMenuIcon} />;
  const onChangeLanguage = (lang) => {
    const localeObj = locales[lang];
    changeLanguage(localeObj.path, localeObj.default);
  };

  return (
    <header>
      <div className={styles.header}>
        <a href={process.env.HOMEPAGE_URL} key="logo" aria-label="Homepage">
          <UniplacesLogo className={styles.header__logo} />
        </a>
        <button
          aria-label="Hamburger menu"
          onClick={() => {setShow(!show)}}
        >
          {icon}
        </button>
      </div>
      <Fade top when={show} duration={250}>
        <div className={styles[`mobileMenu${show ? '' : '__hidden'}`]}>
          <ul className={styles.mobileMenu__list}>
            {
              headerItems.map(({ key, href }) => (
                <li key={key} className={styles.mobileMenu__list__items}>
                  <a href={key === HOW_IT_WORKS_KEY ? href[locale] : href}>
                    <FormattedMessage id={`header.${key}`} />
                  </a>
                </li>
              ))
            }
            <div className={styles.mobileMenu__langSelector}>
              <Dropdown
                defaultValue={locale}
                onChange={onChangeLanguage}
                values={localesValues}
              />
            </div>
          </ul>
        </div>
      </Fade>
    </header>
  );
};

export default HeaderMobile;
